import React from "react";
import { Subscribe } from "unstated";

import { myGlobals, myUtilities } from "../../Utils";
import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";

import {
  CreditCardPaymentLoading,
  CreditCardPaymentConvenienceFeeContent,
  CreditCardPaymentAPIError,
} from "./";
import {callReduxForTxnLimitALert} from '../../App';
import { callReduxAlertAction } from "../../App";
import { makeFirstCardCall } from "../../Utils/AjaxUtil";

class CreditCardModalContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: "null",
    };
    this.apiCallDone = false;
  }
  apiCall =  (invoiceData, paymentData, responseFunction) => {
	let self = this;
    if (
      this.state.content.localeCompare("loading") === 0 &&
      myGlobals.cardFetchCallCompleted
    ) {
      console.log("Value for cardFetchCallCompleted : " + myGlobals.cardFetchCallCompleted);
    	this.doAsync(invoiceData, paymentData, responseFunction, this);
    }
  };
  doAsync = async (invoiceData, paymentData, responseFunction, self) => {
	    const resp = await makeFirstCardCall(invoiceData, paymentData);
	    responseFunction(resp, self).catch(() => {});
	    this.apiCallDone = true;
  }
  responseHandler = async (data, self) => {
	let finalAmt = 0;
    if (
      data != undefined &&
      data.rows != undefined &&
      data.rows[0].totalConvienceFee != undefined &&
      data.rows[0].totalSurchargeAmount != undefined
    ) {
      let lateFee = this.props.paymentData.state.totalLateFee !== null ? this.props.paymentData.state.totalLateFee : 0;
      let isPOA = this.props.invData.state.paymentOnAccount;
      console.log("Payment on account -> " + isPOA);
      console.log("Late Fee -> " + lateFee);
      if (
        data.rows[0].totalConvienceFee > 0 &&
        data.rows[0].totalSurchargeAmount > 0
      ) {
        this.props.paymentData.setCreditCardCheck(false);
        let totalAmt = this.props.invData.getTotalInvoiceAmount(
          this.props.invData.state.selectedInvoices
        );
        totalAmt =
          parseFloat(totalAmt) +
          parseFloat(data.rows[0].totalConvienceFee) +
          parseFloat(data.rows[0].totalSurchargeAmount);

        if (!isPOA) {
          totalAmt = parseFloat(totalAmt) + parseFloat(lateFee);
        }

        if (
          myGlobals.isDiscountEnabled &&
          this.props.invData.state.totalDiscVal !== null
        ) {
          totalAmt =
            parseFloat(totalAmt) -
            parseFloat(this.props.invData.state.totalDiscVal);
        }
        totalAmt = totalAmt.toFixed(2);
        await this.props.invData.setState({
          total: totalAmt,
          multipleTransactionsPerMID: (data?.customValues?.multipleTransactionsPerMID)? "true": "false"
        });
        finalAmt = totalAmt;
        this.setState({
          content: "payment",
          totalConvienceFee: data.rows[0].totalConvienceFee.toFixed(2),
        });
        await myGlobals.selectedStateMethodPaymentContainer(
        !self.props.paymentData.state.isDCFlow ? "CC" : "DC",
          this.props.paymentData,
          data.rows[0].totalConvienceFee.toFixed(2),
          data.rows[0].totalSurchargeAmount.toFixed(2)
        );
      } else if (data.rows[0].totalConvienceFee > 0) {
        this.props.paymentData.setCreditCardCheck(false);
        let totalAmt = this.props.invData.getTotalInvoiceAmount(
          this.props.invData.state.selectedInvoices
        );
        totalAmt =
          parseFloat(totalAmt) + parseFloat(data.rows[0].totalConvienceFee);

        if (!isPOA) {
          totalAmt = parseFloat(totalAmt) + parseFloat(lateFee);
        }

        if (
          myGlobals.isDiscountEnabled &&
          this.props.invData.state.totalDiscVal !== null
        ) {
          totalAmt =
            parseFloat(totalAmt) -
            parseFloat(this.props.invData.state.totalDiscVal);
        }
        totalAmt = totalAmt.toFixed(2);
        await this.props.invData.setState({
          total: totalAmt,
          multipleTransactionsPerMID: (data?.customValues?.multipleTransactionsPerMID)? "true": "false"
        });
        finalAmt = totalAmt;
        this.setState({
          content: "payment",
          totalConvienceFee: data.rows[0].totalConvienceFee.toFixed(2),
        });
        await myGlobals.selectedStateMethodPaymentContainer(
        !self.props.paymentData.state.isDCFlow ? "CC" : "DC",
          this.props.paymentData,
          data.rows[0].totalConvienceFee.toFixed(2),
          null
        );
      } else if (data.rows[0].totalSurchargeAmount > 0) {
        this.props.paymentData.setCreditCardCheck(false);
        let totalAmt = this.props.invData.getTotalInvoiceAmount(
          this.props.invData.state.selectedInvoices
        );
        totalAmt =
          parseFloat(totalAmt) + parseFloat(data.rows[0].totalSurchargeAmount);

        if (!isPOA) {
          totalAmt = parseFloat(totalAmt) + parseFloat(lateFee);
        }

        if (
          myGlobals.isDiscountEnabled &&
          this.props.invData.state.totalDiscVal !== null
        ) {
          totalAmt =
            parseFloat(totalAmt) -
            parseFloat(this.props.invData.state.totalDiscVal);
        }
        totalAmt = totalAmt.toFixed(2);
        await this.props.invData.setState({
          total: totalAmt,
          multipleTransactionsPerMID: (data?.customValues?.multipleTransactionsPerMID)? "true": "false"
        });
        finalAmt = totalAmt;
        this.setState({
          content: "payment",
          totalConvienceFee: data.rows[0].totalConvienceFee.toFixed(2),
        });
        await myGlobals.selectedStateMethodPaymentContainer(
        !self.props.paymentData.state.isDCFlow ? "CC" : "DC",
          this.props.paymentData,
          null,
          data.rows[0].totalSurchargeAmount.toFixed(2)
        );
      } else if (
        data.rows[0].totalConvienceFee == 0 &&
        data.rows[0].totalSurchargeAmount == 0
      ) {
        this.props.paymentData.setCreditCardCheck(false);
        this.props.paymentData.setTotalConvenienceFeeAndSurcharge(null, null);
        
        let totalAmt = this.props.invData.getTotalInvoiceAmount(
          this.props.invData.state.selectedInvoices
        );
        
        if (!isPOA) {
          totalAmt = parseFloat(totalAmt) + parseFloat(lateFee);
        }
        if (
          myGlobals.isDiscountEnabled &&
          this.props.invData.state.totalDiscVal !== null
        ) {
          totalAmt =
            parseFloat(totalAmt) -
            parseFloat(this.props.invData.state.totalDiscVal);
        }
        totalAmt = parseFloat(totalAmt).toFixed(2);

        await this.props.invData.setState({
          total: totalAmt,
          multipleTransactionsPerMID: (data?.customValues?.multipleTransactionsPerMID)? "true": "false"
        });
        
        this.setState({
          content: "payment",
          totalConvienceFee: 0,
        });
        await myGlobals.selectedStateMethodPaymentContainer(!self.props.paymentData.state.isDCFlow ? "CC" : "DC");
      }
      if(data?.rows[0]?.isSurchargeApplicableForTransaction){
        await this.props.invData.setState({isSurchargeApplicableForTransaction: data.rows[0]?.isSurchargeApplicableForTransaction});
      }
      if(data?.rows[0]?.surchargePOEDisclosure){
        await this.props.invData.setState({surchargePOEDisclosure: data.rows[0]?.surchargePOEDisclosure});
      }
    } else {
      this.props.paymentData.setCreditCardCheck(false);
      if(data?.rows && data?.customValues?.errorCode) {
        if(data.customValues.errorCode == "8015" || data.customValues.errorCode == "8014" || data.customValues.errorCode == "8013" || data.customValues.errorCode == "8012" || data.customValues.errorCode == "8011") {
          if(!self.props.paymentData.state.isDCFlow)
          {
            callReduxAlertAction("Error.GuestPay3dsPmidCombinationMsgCC", "The selected invoices require additional authentication and cannot be paid together using a Credit Card.");
          }
          else
          {
            callReduxAlertAction("Error.GuestPay3dsPmidCombinationMsgDC", "The selected invoices require additional authentication and cannot be paid together using a Debit Card.");
          }
        }
        else if(data.customValues.errorCode == "8010") {
          if(!self.props.paymentData.state.isDCFlow)
          {
            callReduxAlertAction("Error.GuestPay3dsPmidCombinationMsg8010CC", "Some of the selected invoices require additional authentication and cannot be paid together using a Credit Card.");
          }
          else
          {
            callReduxAlertAction("Error.GuestPay3dsPmidCombinationMsg8010DC", "Some of the selected invoices require additional authentication and cannot be paid together using a Debit Card.");
          }
        }
        else if(data.customValues.errorCode == "7087") {
                callReduxAlertAction("Error.InvalidPmidCombinationMsg", data.rows);
        }
      }
      await myGlobals.selectedStateMethodPaymentContainer("failure");
      this.setState({
        content: "error",
      });
    }
    myUtilities.checkTransactionLimit(myGlobals.isDCFlow ? "DEBITCARD" : "CREDITCARD", this.props.invData);
  };
  content = () => {
    if (this.state.content.localeCompare("loading") == 0)
      return <CreditCardPaymentLoading />;
    else if (this.state.content.localeCompare("warning") == 0)
      return (
        <CreditCardPaymentConvenienceFeeContent
          totalConvienceFee={this.state.totalConvienceFee}
        />
      );
    else if (this.state.content.localeCompare("payment") == 0) return null;
    else if (this.state.content.localeCompare("error") == 0)
      return <CreditCardPaymentAPIError />;
  };
  loadingCheck = () => {
    if (this.props.loadingTrue && this.state.content.localeCompare("null") == 0)
      this.setState({
        content: "loading",
      });
  };
  render() {
    return (
      <Subscribe to={[PaymentDataContainer]}>
        {(data) => (
          <Subscribe to={[InvoiceDataContainer]}>
            {(invdata) => (
              <div>
                {this.loadingCheck()}
                {this.apiCall(invdata, data, this.responseHandler.bind(this))}
                {this.content()}
              </div>
            )}
          </Subscribe>
        )}
      </Subscribe>
    );
  }
}

export default CreditCardModalContent;
